import React, { useCallback } from "react";
import { StyledPagination, StyledTablePagination } from "../StyledComponents/styled";
import { Box, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../Store/actions";
import { margin } from "@mui/system";
import { right } from "@popperjs/core";

const Pagination = ({ totalCount, reduxStartKeyword, reduxEndKeyword, reduxPaginationKeyword, rightEndBlockConfig, scrollContainerRef, useWindowScroll }) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const currentStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const totalPages = Math.ceil(totalCount / rowsPerPage);
  const paginationKeyword = reduxPaginationKeyword || "pagination";

  const scrollToTop = useCallback(() => {
    const el = scrollContainerRef?.current;
    if (typeof useWindowScroll !== "undefined" && useWindowScroll === true) {
      window.scrollTo({ top: 0 });
    } else {
      if (el && typeof el.scrollTo === "function") {
        el.scrollTo({ top: 0 });
      } else if (el) {
        el.scrollTop = 0;
      }
    }

  }, [scrollContainerRef]);

  const handleChangePage = (event, newPage) => {
    let newPageVal = newPage - 1; // MUI Pagination is 1-based, so we subtract 1 to get the 0-based index
    setPage(newPageVal); // MUI Pagination is 1-based, so we subtract 1 to get the 0-based index

    dispatchAction(
      updateStateData({
        [paginationKeyword]: {
          [reduxStartKeyword]: (newPageVal * rowsPerPage),
          [reduxEndKeyword]: (newPageVal * rowsPerPage) + rowsPerPage,
        },
      })
    );
    // Scroll to top after page change
    scrollToTop();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatchAction(
      updateStateData({
        [paginationKeyword]: {
          [reduxStartKeyword]: 0,
          [reduxEndKeyword]: parseInt(event.target.value, 10),
        },
      })
    );
    // Scroll to top after page size change
    scrollToTop();
  };

  React.useEffect(() => {
    setPage(0);
    setRowsPerPage(10);
  }, [totalCount]);

  return (
    <Box sx={{ width: "100%", mt: -1.5 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <StyledTablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={() => { }}
          rowsPerPageOptions={[]}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={() => { }}
          ActionsComponent={() => null}
          labelDisplayedRows={({ from, to, count }) => `Showing ${from} - ${to} of ${count}`}
          sx={{
            ".MuiTablePagination-toolbar": {
              padding: 0,
              minHeight: "auto",
            },
            ".MuiTablePagination-spacer": {
              display: "none",
            },
          }}
        />

        <Stack direction="row" alignItems="baseline" spacing={1}>
          <StyledPagination
            count={totalPages}
            onChange={handleChangePage}
            variant="text"
            page={page + 1}
            siblingCount={2}
          />
          <StyledTablePagination
            rowsPerPageOptions={[10, 20, 50, 100]}
            component="div"
            count={totalCount}
            page={page}
            onPageChange={() => { }}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={() => null}
            labelDisplayedRows={() => null}
            sx={{
              ".MuiTablePagination-toolbar": {
                padding: 0,
                minHeight: "auto",
              },
              ".MuiTablePagination-spacer": {
                display: "none",
              },
            }}
          />
        </Stack>

        <Box sx={{ visibility: typeof rightEndBlockConfig !== "undefined" ? "visible" : "hidden" }}>
          {
            typeof rightEndBlockConfig !== "undefined" ? rightEndBlockConfig() : (
              <StyledTablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={() => { }}
                rowsPerPageOptions={[]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={() => { }}
                ActionsComponent={() => null}
                labelDisplayedRows={({ from, to, count }) => `Showing ${from} - ${to} of ${count}`}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    padding: 0,
                    minHeight: "auto",
                  },
                  ".MuiTablePagination-spacer": {
                    display: "none",
                  },
                }}
              />
            )
          }

        </Box>
      </Stack>
    </Box>
  );
};

export default Pagination;